import axios from 'axios';

let prefix = "/map"

const MapApi = {
	listMap(payload) {
		return axios.get(prefix + "/list", { params: payload })
	},
	getMapInfo(payload) {
		return axios.get(prefix + "/get", { params: payload })
	},
	archiveMap(payload) {
		return axios.delete(prefix + "/archive", { params: payload })
	},
	createMap(payload) {
		return axios.post(prefix + "/create", payload)
	},
	updateMap(payload) {
		return axios.post(prefix + "/update", payload)
	},
}

export default MapApi;